/******************************************************************************************
 *	JIL Notifications Service
 ********************************************************************************************/
(function() {
  

  angular
    .module('rcServices.customerNotifications', [])
    .constant('CUSTOMER_NOTIFICATION_EVENT_TYPES', {
      CUSTOMER_CHANGED: 'CUSTOMER_CHANGED'
    })
    .service(
      'CustomerNotificationsThrottler',
      /* @ngInject */
      function(_) {
        //Prefix localStorage keys to try and minimize clashes with potential future 3rd party libs
        //or even future RC services which need to persist data in localStorage.
        var LOCAL_STORAGE_PREFIX = 'JILNotif-';
        var getStorageKey = function(eventType, identifier) {
          //If present, remove @AdobeOrg from identifier for a shorter key
          identifier = _.replace(identifier, '@AdobeOrg', '');
          return LOCAL_STORAGE_PREFIX + eventType + identifier;
        };

        //Store timestamp for when an event can be called next and the eventType associated with it.
        var blockList = {};
        this.block = function(eventType, customerId, timeout) {
          var storageKey = getStorageKey(eventType, customerId);
          var timestamp = Date.now() + timeout;
          window.localStorage.setItem(storageKey, timestamp);
          blockList[storageKey] = timestamp;
        };

        //Listen for storage events from other tabs as to keep the in-memory blockList up-to-date
        var storageEventListener = function(event) {
          var key = event.key;
          if (blockList.hasOwnProperty(key)) {
            blockList[key] = parseInt(event.newValue, 10);
          }
        };
        window.addEventListener('storage', storageEventListener, false);

        //Get timestamp for a given storageKey.
        var get = function(storageKey) {
          if (!blockList.hasOwnProperty(storageKey)) {
            var timestamp = parseInt(window.localStorage.getItem(storageKey), 10);
            if (timestamp) {
              blockList[storageKey] = timestamp;
              return timestamp;
            } else {
              return 0;
            }
          }

          return blockList[storageKey];
        };

        //Remove entry from storage given a storageKey
        var remove = function(storageKey) {
          window.localStorage.removeItem(storageKey);
          delete blockList[storageKey];
        };

        //Returns number of milliseconds until the given eventType can be called (again).
        //Returns 0 if the eventType can be called immediately.
        this.getCooldown = function(eventType, customerId) {
          var storageKey = getStorageKey(eventType, customerId);

          var timestamp = get(storageKey);
          var timeLeft = timestamp - Date.now();
          if (timeLeft <= 0) {
            //Time expired, remove and return 0
            remove(storageKey);
            return 0;
          }
          return timeLeft;
        };
      }
    )
    .service(
      'CustomerNotifications',
      /* @ngInject */
      function(
        $http,
        $log,
        $q,
        CustomerNotificationsThrottler,
        CUSTOMER_NOTIFICATION_EVENT_TYPES,
        jilNotifications,
        Settings
      ) {
        //Check if CUSTOMER_CHANGED notification can be sent
        this.canRefreshCustomer = function(customerId) {
          return (
            CustomerNotificationsThrottler.getCooldown(
              CUSTOMER_NOTIFICATION_EVENT_TYPES.CUSTOMER_CHANGED,
              customerId
            ) <= 0
          );
        };

        //Send a CUSTOMER_CHANGED notification
        this.refreshCustomer = function(customerId) {
          //Delay settling the returned promise for a pre-set timeout to give JIL time to
          //refresh data (for an average-sized reseller).
          var deferred = $q.defer();
          var done = function(failed, data, status) {
            window.setTimeout(function() {
              deferred[failed ? 'reject' : 'resolve']({
                error: failed,
                data: data,
                status: status
              });
            }, Settings.TIMEOUT_AFTER_CUSTOMER_REFRESH);
          };

          //Check if the timeout for the CUSTOMER_CHANGED notification expired
          var cooldown = CustomerNotificationsThrottler.getCooldown(
            CUSTOMER_NOTIFICATION_EVENT_TYPES.CUSTOMER_CHANGED,
            customerId
          );
          if (cooldown > 0) {
            $log.info('Rejecting on account of cooldown not expired.');
            deferred.reject({error: true, cooldown: cooldown});
          } else {
            jilNotifications.notifications
              .save(
                {},
                {
                  event_type: CUSTOMER_NOTIFICATION_EVENT_TYPES.CUSTOMER_CHANGED,
                  event_source: 'rc-license-admin-refresh-customer',
                  event_data: {
                    customer_id: customerId
                  }
                }
              )
              .$promise.then(responseData => {
                //Block notifications of type CUSTOMER_CHANGED for the pre-set duration
                CustomerNotificationsThrottler.block(
                  CUSTOMER_NOTIFICATION_EVENT_TYPES.CUSTOMER_CHANGED,
                  customerId,
                  Settings.CUSTOMER_REFRESH_NOTIFICATION_LOCK
                );
                done(false, responseData, 200);
              })
              .catch(err => {
                done(true, err.data, err.status);
              });
          }

          return deferred.promise;
        };
      }
    );
})();
